import { StateProvider } from '@uirouter/angularjs'
import angular from 'angular'

import { ROUTES, STATES } from '../../../lib/routes'

/**
 * =======================================
 * ROUTES CONFIG - STATUS
 * =======================================
 *
 * @module webregister.routes.status
 */
angular
  .module('webregister.routes')
  .config(function ($stateProvider: StateProvider) {
    $stateProvider.state(STATES.STATUS, {
      url: ROUTES.STATUS,
      template: `<status-view></status-view>`,
    })
  })
